import React, { useCallback, useEffect, useState } from "react";
import CounterSection from "../../components/CounterSection/CounterSection";
import EventSiteInfoWrapLeft from "../../components/EventSiteInfoWrap/EventSiteInfoWrapLeft";
import EventSiteInfoWrapRight from "../../components/EventSiteInfoWrap/EventSiteInfoWrapRight";
import EventSlider from "../../components/EventSlider/EventSlider";
import FaqAccordion from "../../components/FaqAccordion/FaqAccordion";
import HeroLanding from "../../components/HeroLanding/HeroLanding";
import PricingSection from "../../components/PricingSection/PricingSection";
import { callApi } from "modules/core/api/services";
import { Product } from "../../types/interfaces/Product";

import { API_URL } from "modules/core/api/constants";
import { useAuth } from "modules/auth/hooks";

export const Landing = () => {
  const [products, setProducts] = useState<Product[]>();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      window.location.assign("/home");
    }
  }, [user]);

  const getProducts = useCallback(async () => {
    const products = await callApi(
      `/v2/products?page=1&per_page=10&exclude_category=single_event_pass`
    );

    setProducts(products.data);
    return;
  }, [API_URL]);

  useEffect(() => {
    const fetchData = async () => {
      await getProducts();
    };

    fetchData();
  }, [getProducts]);

  useEffect(() => {
    document.title = `Home | Staidium`;
  }, []);

  const events = [
    {
      name: "Knights Boulanger",
      league: "CNR",
      date: "01-11-2024",
      images: [
        {
          url: "/Staidium_Basketball.jpg"
        }
      ]
    },
    {
      name: "Chicago Blues",
      league: "CSDHL",
      date: "01-05-2024",
      images: [
        {
          url: "/Staidium_Basketball.jpg"
        }
      ]
    },
    {
      name: "Legacy VTC Tournament",
      league: "High Performance",
      images: [
        {
          url: "/Staidium_Soccer.jpg"
        }
      ]
    },
    {
      name: "Phoenix Field",
      league: "ST. LOIUS HIERACHY 3",
      images: [
        {
          url: "/Staidium_Soccer.jpg"
        }
      ]
    }
  ];

  return (
    <>
      <HeroLanding
        backgroundImage="/staidium_bg-4_1.jpg"
        logoUrl="/Staidium_Logo_vertical.svg"
        mainHeading={"Your Arena for Live Sports Action"}
        secondHeading="Enjoy anytime and anywhere."
        text="Ready to watch? Enter your email to create or restart your membership."
      />

      <EventSiteInfoWrapRight
        imageUrl="/ddd.jpg"
        title="Experience the Thrill of Live Sports in HD!"
        subText="Dive into the Action with Crystal Clear Quality on Smart TV, Roku, Apple TV, and FireStick."
      />

      <CounterSection
        countObjects={[
          { count: 500, title: "Live Hours" },
          { count: 1100, title: "Live Cameras" },
          { count: 100, title: "Leagues & Clubs" },
          { count: 5, title: "Countries" }
        ]}
      />

      <EventSiteInfoWrapLeft
        imageUrl="/Staidium_MultiDevice.jpg"
        title="Never miss a moment, no matter where you are."
        subText="From thrilling live events to your favorite sports on-demand, enjoy seamless streaming on your phone, tablet, laptop, or TV."
      />

      <PricingSection title="Pricing Plan" panels={products ? products : []} />

      <EventSiteInfoWrapRight
        imageUrl="/Staidium_AI.jpg"
        title="Discover the Edge with AI-Driven Technology"
        subText="Elevate your live sports viewing with our state-of-the-art AI-Ecosystem, offering dynamic data analysis and high-definition Live-Streaming."
      />

      <FaqAccordion
        title="Frequently Asked Questions"
        style={{
          background: "#12222d",
          paddingTop: "90px",
          paddingBottom: "90px"
        }}
      />
    </>
  );
};
